<template>
    <div class="sustainable-component admin-club">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-club</div>-->
        <div class="container-fluid p-0 mt-3">
            <div class="row mb-3">
                <div class="col-12 p-0">
                    <CommonLabelContainer title="Skapa klubb" class="mt-5 mb-3">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col">

                                        <v-select name="Department" v-model="selectedDepartment" id="department" item-title="DepartmentName" item-value="DepartmentId" :items="departments" label="Avdelning">
                                            <template v-slot:prepend-item>

                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="container-fluid p-0">
                                            <div class="row">
                                                <div class="col">
                                                    <v-text-field bg-color="white"
                                                                  :rules="[rules.required]"
                                                                  name="ClubName"
                                                                  id="ClubName"
                                                                  type="text"
                                                                  label="Klubbnamn"
                                                                  variant="outlined"
                                                                  v-model="club.ClubName"
                                                                  focused="true"></v-text-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <v-btn variant="tonal" @click="createClub" class="bg-primary">
                                            Skapa
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row">
                <b>Visar {{clubs.length}} klubbar</b>
                <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            <th class="col-2">Klubb</th>
                            <th class="col-2" v-if="this.selectedDepartment == null">Avdelning</th>
                            <th class="col-2">Adress</th>
                            <th class="col-2">Postnr</th>
                            <th class="col-2">Ort</th>
                            <th class="col-2">Telefon</th>
                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in clubs" :key="index">
                            <td>{{item.ClubName}}</td>
                            <td v-if="this.selectedDepartment == null">{{item.DepartmentName}}</td>
                            <td>{{item.Address}}</td>
                            <td>{{item.ZipCode}}</td>
                            <td>{{item.City}}</td>
                            <td>{{item.Telephone}}</td>
                            <td valign="middle">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateClub(item)">Ändra</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="deleteClub(item.ClubId)">Ta bort</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <UpdateClub ref="updateClubModal" @updated="loadClubs"></UpdateClub>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import AdminService from "../../Services/AdminService";
    import CommonLabelContainer from "../../common/common-label-container";
    import UpdateClub from './update/update-club.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    const form = ref(null);
    const updateClubModal = ref(null);

    export default {

        name: 'admin-club',
        props: {
            departmentid: String,
        },
        components: {
            UpdateClub,
            CommonLabelContainer,
            CommonSpinner
        },
        methods: {
            async createClub() {
                var result = await this.form.validate()
                if (result.valid != true)
                    return;
                if(this.selectedDepartment == null){
                    alert("Ange en avdelning")
                    return;
                }
                this.loading++;
                this.club.DepartmentId = this.selectedDepartment;
                try {
                    await AdminService.createClub(this.club);
                    this.displaySnackBar("Klubben skapades");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
                this.loadClubs();
                
            },
            async loadClubs() {
                this.loading++;
                try {
                    if (this.selectedDepartment != null) {
                        this.clubs = await AdminService.getClubsFromDepartment(this.selectedDepartment);
                    }
                    else {
                        this.clubs = await AdminService.getClubs();
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateClub(club) {
                this.loading++;
                this.updateClubModal.open(club)
                this.loading--;
            },
            async deleteClub(clubId) {
                if (confirm("Är du säker att du vill radera klubben?")) {
                    this.loading++;
                    try {
                        await AdminService.deleteClub(clubId);
                        this.displaySnackBar("Klubben togs bort");
                        this.loadClubs();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Det gick inte att radera klubben, kontrollera så att det inte finns ett arbetsplats under denna klubb, i sånt fall måste denna raderas först.")
                    }
                    this.loading--;
                }
            },
            async loadDepartments() {
                this.loading++;
                try {
                    var departments = [{ DepartmentName: 'Ingen vald', DepartmentId: null }, ...await AdminService.getDepartments()];
                    this.departments = departments;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
            
        },

        data() {
            return {
                rules: ValidationService.rules(),
                club: {
                    ClubName: '',
                    DepartmentId: 0,
                },
                clubs: [],
                selectedDepartment: null,
                departments: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedDepartment: function (newVal) {
                this.selectedClub = null;
                this.loadClubs(newVal);
            },
        },
        mounted() {
            this.loadDepartments();
            this.loadClubs();
        },
        setup() {
            return { form, updateClubModal }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>